import { useWeb3ModalStylesStyles } from './useWeb3ModalStylesStyles';

export const Web3ModalStyles = () => {
  useWeb3ModalStylesStyles();

  return null;
};
